import { render, staticRenderFns } from "./DungeonWinNext.vue?vue&type=template&id=2334b861&scoped=true"
import script from "./DungeonWinNext.vue?vue&type=script&lang=js"
export * from "./DungeonWinNext.vue?vue&type=script&lang=js"
import style0 from "./DungeonWinNext.vue?vue&type=style&index=0&id=2334b861&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2334b861",
  null
  
)

export default component.exports